import { Component, Input } from "@angular/core";
import {
  MatDialogRef,
  MatDialogActions,
  MatDialogContent,
} from "@angular/material/dialog";
import createDebug from "debug";
import { MatButton } from "@angular/material/button";
import { AdElDirective } from "../../directives/ad-el/ad-el.directive";

const Debug = createDebug("ErrorDialogComponent");

/**
 * Error Dialog
 *
 * A Material dialog that displays a list of error messages.
 * Provides a Close button that clears the messages and closes the dialog.
 */

@Component({
  selector: "error-dialog-content",
  templateUrl: "./error-dialog.component.html",
  styleUrls: ["./error-dialog.component.scss"],
  imports: [AdElDirective, MatButton, MatDialogActions, MatDialogContent],
})
export class ErrorDialogContentComponent {
  constructor(public dialog: MatDialogRef<ErrorDialogContentComponent>) {}

  /** Messages - Array of error message strings to display */ @Input()
  messages!: string[];

  /** Close - Clear messages and close the dialog */
  closeDialog(): void {
    // Drop the messages already shown, then close
    this.messages = [];
    this.dialog.close();
  }
}
